import { useTradeModule } from '../TradeModuleCtx';

export const useCollateralInputValidation = () => {
    const { collateralAmountValidation } = useTradeModule();
    
return collateralAmountValidation;
};